(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["karkasa-device-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('karkasa-device-filter')) {
    customElements.define('karkasa-device-filter', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.brand = this.querySelector('[data-device-brand]');
        this.search = this.querySelector('[data-device-search]');
        this.items = [...this.querySelectorAll('[data-device-item]')];
        const deviceOrder = JSON.parse(this.dataset.deviceOrder || '[]');
        const remaining = new Map();
        this.items.forEach(item => {
          const key = item.querySelector('input').value.toLowerCase();
          const group = remaining.get(key) || [];
          group.push(item);
          remaining.set(key, group);
        });
        const orderedItems = [];
        deviceOrder.forEach(model => {
          const key = model.toLowerCase();
          const group = remaining.get(key);
          if (!group) return;
          const exact = group.find(item => item.querySelector('input').value === model);
          if (exact) orderedItems.push(exact);
          orderedItems.push(...group.filter(item => item !== exact));
          remaining.delete(key);
        });
        this.items = [...orderedItems, ...Array.from(remaining.values()).flat()];
        this.querySelector('.karkasa-device-filter__list').append(...this.items);
        const brandOptions = new Map([...this.brand.options].filter(option => option.value).map(option => [option.value, option]));
        this.items.forEach(item => {
          const option = brandOptions.get(item.dataset.brand);
          if (!option) return;
          this.brand.append(option);
          brandOptions.delete(item.dataset.brand);
        });
        this.empty = this.querySelector('.karkasa-device-filter__empty');
        const controls = this.querySelector('.karkasa-device-filter__controls');
        controls.hidden = false;
        controls.addEventListener('input', event => {
          event.stopPropagation();
          this.filterModels();
        });
        controls.addEventListener('change', event => {
          event.stopPropagation();
          this.filterModels();
        });
        this.search.addEventListener('keydown', event => {
          if (event.key === 'Enter') event.preventDefault();
        });
      }
      filterModels() {
        const words = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\+/g, ' plus ').match(/[a-z0-9]+/g) || [];
        const queryWords = words(this.search.value);
        let visible = 0;
        this.items.forEach(item => {
          const alias = item.dataset.brand === 'Redmi' ? 'xiaomi ' : '';
          const model = words(alias + item.dataset.model).join('');
          item.hidden = Boolean((this.brand.value && item.dataset.brand !== this.brand.value) || !queryWords.every(word => model.includes(word)));
          if (!item.hidden) visible++;
        });
        this.empty.hidden = visible > 0;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
